import styles from "../LogoBanner/LogoBanner.module.scss";
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import Srcset from "@/components/common/Srcset";

function LogoBanner(props) {
  let settings_3 = {
    dots: false,
    infinite: props.logos?.length > 6 ? true:false,
    speed: 7000, 
    slidesToShow: props.slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    variableWidth:true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1296,
        settings: {
          infinite: props.logos?.length > 4 ? true:false,
          slidesToShow:4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          infinite: props.logos?.length > 5 ? true:false,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          infinite: props.logos?.length > 2 ? true:false,
          slidesToShow: 2.5,
        },
      },
    ],
  };

  return (
    <>
      <div
        className={`${
          styles.logo_banner
        } bg-${props.backgroundColor.toLowerCase()} ${props.wrapperClass?props.wrapperClass:""}`}
      >
        <div className={`${styles.logo_wrapper} ${props.logos?.length<7?styles.logo_limit:""}`}>
          <Slider {...settings_3}>
            {props.logos &&
              props.logos.map((logo, index) => {
                return (
                  <a key={index} {...logo.logoLink?{href:logo.logoLink}:{}}>
                    <Srcset
                      height="40"
                      width="100%"
                      src={logo.image}
                      alt={logo.logoAltText? logo.logoAltText : "logo"}
                      className={props.logoClass?props.logoClass:""}
                    />
                  </a>
                );
              })}
          </Slider>
        </div>
      </div>
    </>
  );
}

export default LogoBanner;
